import React from 'react';
import PropTypes from 'prop-types';
import StripeDefs from 'components/stripe-defs';
import {getMask, getTranslate} from 'utils/attribute-util';
import styles from './index.css';

export default class DifferenceRect extends React.Component {
  static propTypes = {
    active: PropTypes.bool,
    fillOpacity: PropTypes.number,
    height: PropTypes.number,
    style: PropTypes.object,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    active: false,
    fillOpacity: 0.65,
    height: 0,
    style: {},
    width: 0,
    x: 0,
    y: 0,
  };

  getStyle(style, maskID) {
    return {
      ...style,
      mask: getMask(maskID),
    };
  }

  render() {
    const style = this.getStyle(this.props.style, StripeDefs.getMaskID());
    const translate = getTranslate(this.props.x, this.props.y);
    return this.props.active ? (
      <g className={styles.DifferenceRect} transform={translate}>
        <rect
          fillOpacity={this.props.fillOpacity}
          height={this.props.height}
          style={style}
          width={this.props.width}
        />
      </g>
    ) : null;
  }
}
